var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 853,
    height: 134,
    viewBox: "0 0 853 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.56 131.63L281.484 114.633L282.937 99.5805C283.072 98.1773 282.609 96.7822 281.662 95.7386C280.714 94.695 279.37 94.0999 277.96 94.0999H268.103L261.755 84.3599H273.06C275.633 84.3599 277.786 82.4076 278.036 79.8471L278.226 77.9048L300.302 113.411L299.73 118.881C299.583 120.289 300.041 121.695 300.989 122.747C301.937 123.799 303.287 124.4 304.703 124.4H326.823C329.384 124.4 331.53 122.466 331.796 119.919L332.262 115.462L353.334 115.502L352.982 118.882C352.835 120.29 353.292 121.695 354.24 122.747C355.189 123.799 356.538 124.4 357.955 124.4H380.075C382.634 124.4 384.781 122.467 385.047 119.921L385.504 115.562L404.184 115.597L407.254 121.659C408.106 123.34 409.83 124.4 411.715 124.4H435.095C435.556 124.4 436.008 124.336 436.441 124.215C436.874 124.336 437.326 124.4 437.788 124.4H461.588C463.553 124.4 465.336 123.248 466.145 121.457L468.735 115.719L505.844 115.788L506.984 120.562C507.522 122.812 509.534 124.4 511.848 124.4H535.788C537.344 124.4 538.812 123.675 539.758 122.439C540.704 121.203 541.021 119.597 540.614 118.095L540.008 115.852L552.527 115.876C561.404 122.357 572.535 125.8 584.516 125.8C594.756 125.8 605.975 123.239 616.326 115.996L628.943 116.02L628.645 118.882C628.498 120.29 628.956 121.695 629.904 122.747C630.852 123.799 632.202 124.4 633.618 124.4H655.738C658.294 124.4 660.438 122.472 660.71 119.931L661.121 116.08L685.972 116.127L689.547 122C690.454 123.49 692.073 124.4 693.818 124.4H717.058C718.854 124.4 720.511 123.437 721.401 121.877C722.291 120.318 722.276 118.4 721.362 116.855L720.97 116.193L740.7 116.23C745.127 119.255 749.282 121.528 754.138 123.117C759.02 124.715 764.325 125.529 770.92 125.953C779.267 126.489 790.35 126.42 806.133 126.322C814.735 126.269 824.733 126.207 836.446 126.23H836.455C840.961 126.231 844.73 123.87 846.855 120.468L851.97 129.403C853.115 131.403 851.671 133.893 849.366 133.893L304.309 133.893C304.256 133.896 304.204 133.898 304.151 133.899C304.116 133.9 304.08 133.9 304.044 133.9H296.749C295.059 133.9 293.483 133.046 292.56 131.63ZM752.908 116.253L842.218 116.42C841.287 118.611 839.127 120.23 836.457 120.23C824.488 120.207 814.378 120.27 805.749 120.323C775.053 120.515 763.105 120.59 752.908 116.253ZM273.06 79.3599H258.497L226.492 30.2486L227.56 19.9999H242.226L254.847 40.2999H247.58L245.62 59.3399H266.684L273.886 70.9235L273.06 79.3599ZM271.361 99.0999L277.109 107.919L277.96 99.0999H271.361ZM227.261 0.399902C228.327 0.399902 229.346 0.739433 230.185 1.34406L221.204 22.1342L212.077 8.12982C209.91 4.80387 212.296 0.399902 216.266 0.399902H227.261ZM233.58 6.09368L239.117 14.9999H229.732L233.58 6.09368ZM252.092 45.2999H257.955L263.576 54.3399H251.161L252.092 45.2999ZM304.703 119.4L305.12 115.411L327.236 115.453L326.823 119.4H304.703ZM357.955 119.4L358.36 115.511L380.478 115.553L380.075 119.4H357.955ZM411.715 119.4L409.794 115.608L433.133 115.652L435.095 119.4H411.715ZM437.788 119.4L439.582 115.664L463.254 115.708L461.588 119.4H437.788ZM511.848 119.4L510.987 115.798L534.826 115.843L535.788 119.4H511.848ZM584.516 120.8C576.423 120.8 568.844 119.096 562.241 115.894L606.472 115.977C599.122 119.485 591.57 120.8 584.516 120.8ZM633.618 119.4L633.969 116.029L656.093 116.071L655.738 119.4H633.618ZM693.818 119.4L691.832 116.138L715.155 116.182L717.058 119.4H693.818Z",
    fill: "url(#paint0_linear_359_15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M836.457 120.229C769.347 120.1 760.678 122.679 743.904 111.151C720.928 95.3598 715.004 64.0774 730.673 41.2793C746.341 18.4812 777.669 12.801 800.645 28.5921C817.419 40.1202 818.118 49.138 842.288 111.745C843.864 115.846 840.85 120.23 836.457 120.229ZM789.609 81.7849C796.137 72.2857 793.669 59.2514 784.096 52.6717C774.522 46.0921 761.469 48.4589 754.94 57.9581C748.412 67.4573 750.88 80.4916 760.453 87.0713C770.027 93.6509 783.08 91.2841 789.609 81.7849Z",
    fill: "url(#paint1_linear_359_15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 120.8C51.8 120.8 71.96 110.44 71.96 88.6C71.96 75.58 65.24 67.6 49.28 61.02L43.26 58.64C34.02 54.86 30.52 51.78 30.52 47.16C30.52 41.84 35.28 38.34 41.58 38.34C47.74 38.34 52.78 41.42 56.56 48.98L74.06 39.74C70.42 29.24 60.2 18.6 42.28 18.6C23.8 18.6 8.68 30.08 8.68 48C8.68 63.12 19.32 70.4 31.92 75.44L36.68 77.4C45.78 81.18 48.86 84.26 48.86 90C48.86 97.84 42.56 100.78 35.56 100.78C25.76 100.78 20.58 94.2 18.76 86.78L0 95.18C2.38 110.44 16.94 120.8 34.3 120.8Z",
    fill: "url(#paint2_linear_359_15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.186 119.4H119.686L146.986 57.24L161.686 119.4H179.186L230.766 0H207.526L173.166 81.46L159.866 20H142.366L116.466 81.46L104.706 20H81.3258L102.186 119.4Z",
    fill: "url(#paint3_linear_359_15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.2 119.4H276L277.96 99.1H241.42L243.52 79.36H273.06L275.02 59.34H245.62L247.58 40.3H283.14L285.1 20H227.56L217.2 119.4Z",
    fill: "url(#paint4_linear_359_15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.703 119.4H326.823L335.083 40.3H357.903L360.003 20H292.803L290.563 40.3H312.963L304.703 119.4Z",
    fill: "url(#paint5_linear_359_15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357.955 119.4H380.075L383.435 87.34H395.475L411.715 119.4H435.095L416.195 83.28C428.655 77.4 436.775 65.64 436.775 50.66C436.775 31.62 424.035 20 404.435 20H368.315L357.955 119.4ZM385.535 68.44L388.475 40.3H400.235C408.775 40.3 414.375 43.1 414.375 52.2C414.375 62.98 406.535 68.44 397.155 68.44H385.535Z",
    fill: "url(#paint6_linear_359_15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M584.516 120.8C598.516 120.8 614.476 115.62 626.936 98.4L612.236 87.2C604.956 95.6 597.256 99.8 587.316 99.8C572.336 99.8 560.576 89.3 560.576 71.94C560.576 53.18 574.856 39.6 592.776 39.6C602.996 39.6 610.556 43.8 616.016 52.2L632.956 41C624.136 23.78 608.176 18.6 594.316 18.6C563.516 18.6 537.756 42.96 537.756 74.74C537.756 103.16 558.476 120.8 584.516 120.8Z",
    fill: "url(#paint7_linear_359_15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M633.618 119.4H655.738L658.398 94.48L670.298 80.76L693.818 119.4H717.058L684.438 64.24L722.658 20H698.158L661.478 64.1L666.098 20H643.978L633.618 119.4Z",
    fill: "url(#paint8_linear_359_15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.908 20H485.528L437.788 119.4H461.588L468.728 103.58H508.068L511.848 119.4H535.788L508.908 20ZM494.348 47.3L478.108 83.14H503.028L494.348 47.3Z",
    fill: "url(#paint9_linear_359_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_15",
    x1: 211.258,
    y1: 0.399902,
    x2: 264.545,
    y2: 256.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_15",
    x1: 721.915,
    y1: 19.6523,
    x2: 821.014,
    y2: 138.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_15",
    x1: 0,
    y1: 0,
    x2: 39.2882,
    y2: 235.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_359_15",
    x1: 0,
    y1: 0,
    x2: 39.2882,
    y2: 235.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_359_15",
    x1: 0,
    y1: 0,
    x2: 39.2882,
    y2: 235.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_359_15",
    x1: -1.96004,
    y1: 11.4,
    x2: 30.6682,
    y2: 226.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_359_15",
    x1: -1.96004,
    y1: 11.4,
    x2: 30.6682,
    y2: 226.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_359_15",
    x1: -1.96004,
    y1: 11.4,
    x2: 30.6682,
    y2: 226.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_359_15",
    x1: -1.96004,
    y1: 11.4,
    x2: 30.6682,
    y2: 226.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_359_15",
    x1: -1.96004,
    y1: 11.4,
    x2: 30.6682,
    y2: 226.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727171"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBig);
export default __webpack_public_path__ + "static/media/big.11374e7ef828c896431e22a12930b0a7.svg";
export { ForwardRef as ReactComponent };